export const ADD_CLIP = 'videos/ADD_CLIP';
export const EDIT_CLIP = 'videos/EDIT_CLIP';
export const REMOVE_CLIP = 'videos/REMOVE_CLIP';
export const SET_DURATION = 'videos/SET_DURATION';
export const REMOVE_ALL_CLIPS = 'videos/REMOVE_ALL_CLIPS';
export const CLIP_CHANGE = 'videos/CLIP_CHANGE';
export const PAUSE_VIDEO = 'videos/PAUSE_VIDEO';
export const PLAY_VIDEO = 'videos/PLAY_VIDEO';
